module.exports = {
          srcSet: __webpack_public_path__ + "4a1f4a4bd3dfa18fa015056b30718c37-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "4a1f4a4bd3dfa18fa015056b30718c37-120.png",width: 120,height: 120}],
          src: __webpack_public_path__ + "4a1f4a4bd3dfa18fa015056b30718c37-120.png",
          toString:function(){return __webpack_public_path__ + "4a1f4a4bd3dfa18fa015056b30718c37-120.png"},
          
          width: 120,
          height: 120
        }